import { render, staticRenderFns } from "./trainingModulePageShortAnswer.vue?vue&type=template&id=a986f5ec&scoped=true&"
import script from "./trainingModulePageShortAnswer.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageShortAnswer.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageShortAnswer.vue?vue&type=style&index=0&id=a986f5ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a986f5ec",
  null
  
)

export default component.exports